import { DYNAMIC_MERCHANTS_FILTER_CHANGED } from './types';

export const triggerFilterIsChangedGAEvent = (selectedFilterName, filteredMerchantsNumber, title) => ({
  type: DYNAMIC_MERCHANTS_FILTER_CHANGED,
  selectedFilterName,
  filteredMerchantsNumber,
  title,
});
